import { doesExist } from 'utils/tsHelpers';
import { parseDate } from 'utils/datetime';
import { QUERY_BUILDER_DATE_FORMAT } from 'utils/date';
import { useDisplayDateTz } from 'utils/hooks/datetime';
import { isEmptyString } from 'utils/stringHelpers';
import { updateDateToParse } from '../utils/updateDateToParse';
import { validateIsRelativeDate } from 'modules/queryBuilder/utils';

export const useGetDisplayDate = (date: string | null, timeZone: string) => {
  const displayDateTz = useDisplayDateTz();
  if (!doesExist(date) || isEmptyString(date)) return null;
  if (validateIsRelativeDate(date)) {
    return date;
  }
  return displayDateTz(parseDate(updateDateToParse(date)), QUERY_BUILDER_DATE_FORMAT, timeZone);
};
